<mat-toolbar-row class="bg-zinc-50" fxLayoutAlign="space-between center">
    <h2 matDialogTitle class="text-lg font-medium text-gray-700">{{ title | translate }}</h2>
    <span class="example-spacer"></span>
    <mat-icon class="close-dialog pointer" (click)="dialogRef.close()">close</mat-icon>
</mat-toolbar-row>

<div mat-dialog-content fxLayout="column" fxLayoutAlign="start" class="p-24">
    <form [formGroup]="certificationForm" *ngIf="certificationForm; else shimmer">
        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="32px">
            <div fxFlex="50" fxLayout="column">
                <div class="w-100-p mb-24" fxLayout="column" fxLayoutAlign="center flex-start">
                    <label class="mb-8 text-lightgreytextcolor text-xs">{{ 'USER.SINGULAR' | translate }}</label>
                    <div fxLayout="row" fxLayoutAlign="flex-start center">
                        <div class="relative">
                            <img
                                class="avatar"
                                *ngIf="certificateRecord.owner?.avatar.src; else initials"
                                [alt]="certificateRecord.owner.fullName"
                                [src]="certificateRecord.owner.avatar.src"
                            />
                            <ng-template #initials>
                                <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ certificateRecord.owner.fullName | initials }}</div>
                            </ng-template>
                            <ng-template [onlineStateIndicator]="certificateRecord.owner.isOnline"> </ng-template>
                        </div>
                        <div>
                            <span>{{ certificateRecord.owner.fullName }}</span>
                        </div>
                    </div>
                </div>

                <app-certificate-taxonomy-fields
                    [providerControl]="certificationForm.get('provider')"
                    [certificationControl]="certificationForm.get('certification')"
                    [disabled]="isViewOnly"
                    [initialProvider]="certificateRecord.officialCertificateMetadata.certification.provider"
                    [initialCertification]="certificateRecord.officialCertificateMetadata.certification"
                    (providerChange)="onProviderSelected($event)"
                    (certificationChange)="onCertificationSelected($event)"
                ></app-certificate-taxonomy-fields>

                <div class="w-100-p" fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="12px" fxLayoutAlign="space-between center">
                    <mat-form-field class="w-100-p">
                        <input
                            matInput
                            [matDatepicker]="issueDatePicker"
                            placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.ISSUE_DATE' | translate }}"
                            formControlName="issueDate"
                            (focus)="!isViewOnly && issueDatePicker.open()"
                            (ngModelChange)="updateExpirationDate()"
                        />
                        <mat-datepicker-toggle matSuffix [for]="issueDatePicker" [disabled]="isViewOnly"></mat-datepicker-toggle>
                        <mat-datepicker #issueDatePicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field class="w-100-p" *ngIf="selectedCertification?.hasExpirationDate">
                        <input
                            matInput
                            [matDatepicker]="expirationDatePicker"
                            [min]="minDate"
                            placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.EXPIRATION_DATE' | translate }}"
                            formControlName="expirationDate"
                            (focus)="!isViewOnly && expirationDatePicker.open()"
                        />
                        <mat-datepicker-toggle matSuffix [for]="expirationDatePicker" [disabled]="isViewOnly"></mat-datepicker-toggle>
                        <mat-datepicker #expirationDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <mat-checkbox formControlName="notifyAboutExpiration" class="my-12" *ngIf="isToDoFeatureEnabled && selectedCertification?.hasExpirationDate">
                    {{ 'CERTIFICATE.NOTIFY_WHEN_IS_ABOUT_TO_EXPIRE' | translate }}
                </mat-checkbox>

                <mat-slide-toggle
                    class="my-12"
                    [formControl]="hasEndDate"
                    (change)="onChangeEndDateToggle($event)"
                    *ngIf="selectedCertification?.certificationName === 'other' && !isViewOnly"
                    >{{ 'GENERAL.LABEL.HAS_END_DATE' | translate }}</mat-slide-toggle
                >

                <div class="p-24 bg-lightgreybackground" *ngIf="hasEndDate.value">
                    <mat-form-field class="w-100-p">
                        <input
                            matInput
                            [matDatepicker]="expirationDatePicker"
                            [min]="minDate"
                            placeholder="{{ 'PAGE.CERTIFICATIONS.LABEL.EXPIRATION_DATE' | translate }}"
                            formControlName="expirationDate"
                            (focus)="!isViewOnly && expirationDatePicker.open()"
                        />
                        <mat-datepicker-toggle matSuffix [for]="expirationDatePicker" [disabled]="isViewOnly"></mat-datepicker-toggle>
                        <mat-datepicker #expirationDatePicker></mat-datepicker>
                    </mat-form-field>

                    <mat-checkbox formControlName="notifyAboutExpiration" class="mt-12" *ngIf="isToDoFeatureEnabled">
                        {{ 'CERTIFICATE.NOTIFY_WHEN_IS_ABOUT_TO_EXPIRE' | translate }}
                    </mat-checkbox>
                </div>

                <div class="p-24 bg-lightgreybackground mt-8 replace-wrapper" [class.column]="selectedCertificateToReplace" *ngIf="!isViewOnly">
                    <label class="text-base text-darktextcolor font-medium">{{ 'PAGE.CERTIFICATIONS.LABEL.REPLACEMENT_CERTIFICATE' | translate }}</label>
                    <app-white-button
                        [label]="'PAGE.CERTIFICATIONS.LABEL.SELECT_CERTIFICATE' | translate"
                        (click)="openReplaceCertificateDialog(certificateRecord)"
                        *ngIf="!selectedCertificateToReplace"
                    ></app-white-button>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="replace-file-wrapper" *ngIf="selectedCertificateToReplace">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon class="mr-8">description</mat-icon>
                            <span>{{ selectedCertificateToReplace?.certificateFullName }}</span>
                        </div>
                        <mat-icon class="pointer ml-16" (click)="onRemoveReplacementCertificate()">close</mat-icon>
                    </div>
                </div>
            </div>

            <div fxFlex="50" fxLayout="column">
                <div class="w-100-p mb-24" fxLayout="row" fxLayoutAlign="space-between center">
                    <h2 class="m-0 lightgreybackground">{{ 'ALTERNATIVE.CERTIFICATE.SINGULAR' | translate }}</h2>
                    <app-white-button
                        [svgIcon]="'download'"
                        [label]="'GENERAL.BUTTON.DOWNLOAD'"
                        (onClick)="downloadCertificate()"
                        *ngIf="fileURL && !isViewOnly"
                    ></app-white-button>
                </div>
                <div style="width: 100%" *ngIf="fileURL; else noCertificateFile" class="!hidden sm:!block border border-gray-300">
                    <app-pdf-web-viewer *ngIf="fileURL" [pdf]="fileURL" height="400px" (load)="load($event)"></app-pdf-web-viewer>
                </div>
                <ng-template #noCertificateFile>
                    <div
                        class="file-drop-container certificates-list w-100-p h-188"
                        cdkDropList
                        (drop)="onFileDropped($event)"
                        (dragover)="onDragOver($event)"
                        (dragleave)="onDragLeave($event)"
                        [class.drag-over]="isDragOver"
                    >
                        <div>
                            <div fxLayout="column" fxLayoutAlign="center center">
                                <app-white-button
                                    class="my-12"
                                    [label]="'CONTENT.BUTTON.UPLOAD'"
                                    (onClick)="fileInput.click()"
                                    [showThreeDots]="true"
                                    [disabled]="isViewOnly"
                                ></app-white-button>
                                <input
                                    class="bg-white rounded-sm p-8 pointer border border-gray-300"
                                    type="file"
                                    style="display: none"
                                    (change)="fileChange($event.target.files)"
                                    [placeholder]="'CONTENT.BUTTON.UPLOAD' | translate"
                                    accept=".pdf"
                                    #fileInput
                                />
                                <p *ngIf="!uploadedCertificateFiles.length">
                                    {{ 'PAGE.MODULE_FORM.TAB.CERTIFICATE_SETTINGS.DIALOGS.ADD_CERTIFICATE_TEMPLATE_TO_MODULE.LABELS.OR_DRAG_AND_DROP' | translate }}
                                </p>
                                <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="uploadedCertificateFiles.length">
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        <mat-icon class="mr-8">description</mat-icon>
                                        <span>{{ uploadedCertificateFiles[0]?.name }}</span>
                                    </div>
                                    <mat-icon class="pointer" (click)="onRemoveAddedCertificate()">close</mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </form>
    <ng-template #shimmer>
        <div class="shimmer-container p-0" fxLayout="row" fxLayoutAlign="flex-start space-between" fxLayoutGap="32px">
            <div class="shimmer w-100-p">
                <div class="shimmer-title max-w-60 mb-24 animate"></div>
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div class="shimmer-title max-w-sm mb-24 animate"></div>
            </div>

            <div class="shimmer w-100-p">
                <div class="shimmer-title max-w-sm mb-32 animate"></div>
                <div fxLayout="row wrap">
                    <div class="shimmer-card module animate" fxLayout="row" fxLayoutAlign="flex-start space-between" fxFlex="1 0 calc(100%-8px)"></div>
                </div>
            </div>
        </div>
    </ng-template>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center" *ngIf="!isViewOnly">
    <app-white-button fxHide fxShow.gt-xs class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button
        [label]="'GENERAL.BUTTON.SAVE' | translate"
        (onClick)="saveSelected()"
        [disabled]="(!certificationForm?.valid || !certificationForm?.dirty) && !isFileUpdated && !isEndDateToggleChanged"
        [isLoading]="isSaveButtonLoading"
    ></app-flat-button>
</div>
